/**
 * Core move contracts for the Legendary Arena game engine.
 *
 * Defines the canonical move names, payload types, and the engine-wide
 * MoveResult/MoveError result contract. All move validators in every
 * future packet must import and return these types.
 *
 * No boardgame.io imports. No implementations. Contracts only.
 */
/**
 * All core move names in canonical order. Single source of truth.
 *
 * Used for drift-detection testing — if a move is added to the CoreMoveName
 * union type, it must also appear in this array (and vice versa).
 */
export const CORE_MOVE_NAMES = [
    'drawCards',
    'playCard',
    'endTurn',
];
//# sourceMappingURL=coreMoves.types.js.map